import { render, staticRenderFns } from "./FileHandler.vue?vue&type=template&id=1faff092&scoped=true&"
import script from "./FileHandler.vue?vue&type=script&lang=js&"
export * from "./FileHandler.vue?vue&type=script&lang=js&"
import style0 from "./FileHandler.vue?vue&type=style&index=0&id=1faff092&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1faff092",
  null
  
)

export default component.exports